import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ClientsContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
            <div class="portfolio-area circle-icon default-padding bg-gray">
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="site-heading text-center">
        
          <h2>CLIENT LIST</h2>
         
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-12 clients-box"> 
        
      
        <div class="row masonary">
          <div id="portfolio-grid" class="portfolio-items col-4">
            <div class="portfolio-items"> 
            {this.props.clients.map((item, index) => (
              <div class="pf-item construction pf-project">
                <div class="item">
                  <div class="effect-up"> <img src={item.image} alt={item.title}/> </div>
                  <div class="info">
                    <h5>{item.title}<br /><br /></h5>
                  </div>
					
                </div>
				  
              </div>

            ))}
               
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
        </div>
       

    );
 
    }
}

export default ClientsContent;